import React, { useContext } from "react";
import moment from "moment";
import PropTypes from "prop-types";

import { useTranslation } from "@common/hooks/translation";
import TicketSkeleton from "@common/components/ticketSkeleton";
import Money from "@app/dev/terminal/components/money";

import { BetStatus } from "../components/betStatus";
import BetType from "../components/betType";
import { BetStateEnum } from "@app/dev/constants/enums/betState";
import { PreferencesContext } from "@common/contexts/preferences";
import OddConverter from '@common/helpers/oddConverter';
import Config from "@app/dev/config/main";

const TicketDetailsBetBuilder = ({ ticket }) => {
  const t = useTranslation();
  const [preferences] = useContext(PreferencesContext);

  const { dataFromSwarm } = ticket;

  return (
    <TicketSkeleton dark>
      <div className="ticket-section">
        <div className="ticket-info-row">
          <p>{t("Status")}</p>
          <BetStatus data={ticket} />
        </div>
        <div className="ticket-info-row">
          <p>{t("Id")}</p>
          <span>{dataFromSwarm?.id ?? ticket?.id}</span>
        </div>
        <div className="ticket-info-row">
          <p>{t("Date")}</p>
          <span>{moment(dataFromSwarm?.created).format("DD/MM/YYYY HH:mm:ss")}</span>
        </div>
        <div className="ticket-info-row">
          <p>{t("Bet Type")}</p>
          <BetType data={ticket} />
        </div>
      </div>
      <div className="ticket-section">
        <div className="ticket-info-row">
          <p>{dataFromSwarm.bet_details.sport_name}</p>
        </div>
        <div className="ticket-info-row">
          <p>{dataFromSwarm.bet_details.fixture}</p>
        </div>
        <div className="ticket-info-row">
          <p>{dataFromSwarm.bet_details?.description.join(", ")}</p>
        </div>
      </div>
      <div className="ticket-section">
        <div className="ticket-info-row">
          <p>{t("Total odd")}</p>
          <p>{OddConverter(Config, dataFromSwarm.price, preferences.oddsFormat) ?? "-"}</p>
        </div>
        <div className="ticket-info-row">
          <p>{t("Amount")}</p>
          <p>
            <Money amount={dataFromSwarm.amount} />
          </p>
        </div>
        {!!dataFromSwarm.stake_tax_amount && !!dataFromSwarm.amount && (
          <div className="ticket-info-row">
            <p>{t("Total stake")}</p>
            <p>
              <Money
                amount={
                  dataFromSwarm.stake_tax_amount +
                  dataFromSwarm.amount
                }
              />
            </p>
          </div>
        )}
        {!!dataFromSwarm.state_id === BetStateEnum.Accepted && (
          <div className="ticket-info-row">
            <p>{t("Possible win")}</p>
            <p>
              <Money
                amount={
                  dataFromSwarm.possible_win -
                  dataFromSwarm.possible_tax_amount
                }
              />
            </p>
          </div>
        )}
        {!!dataFromSwarm.state_id !== BetStateEnum.Accepted && (
          <div className="ticket-info-row">
            <p>{t("Won amount")}</p>
            <p>
              <Money
                amount={
                  dataFromSwarm.win_amount -
                  dataFromSwarm.tax_amount
                }
              />
            </p>
          </div>
        )}
      </div>
    </TicketSkeleton>
  );
};

TicketDetailsBetBuilder.propTypes = {
  ticket: PropTypes.object.isRequired,
};

export default TicketDetailsBetBuilder;
